
export interface FilterRule {
  field: "summary" | "description";
  kind: "contains" | "regex";
  value: string;
}

export enum GoogleEventResponseStatus {
  needs_action = "needsAction",
  declined = "declined",
  tentative = "tentative",
  accepted = "accepted"
}

export interface StatusTransform {
  needs_action: GoogleEventResponseStatus;
  declined: GoogleEventResponseStatus;
  tentative: GoogleEventResponseStatus;
  accepted: GoogleEventResponseStatus;
  deleted_declined: boolean;
}

export enum EventVisibility {
  DEFAULT = "default",
  PRIVATE = "private",
  CONFIDENTIAL = "confidential",
  PUBLIC = "public",
  KEEP_ORIGINAL = "keep_original"
}

export enum Transparency {
  keep_original = "keep_original",
  set_to_transparent = "set_to_transparent",
  set_to_opaque = "set_to_opaque",
  ignore_transparent = "ignore_transparent",
  ignore_opaque = "ignore_opaque"
}

export interface SyncRuleBuffer {
  minutes_before: number | null,
  minutes_after: number | null,
}

export interface EventReminder {
  method: "email" | "popup",
  minutes: number,
}

export interface EventReminders {
  useDefault: boolean,
  overrides: EventReminder[],
}


export interface SyncRule {
  source: string,
  destination: string,
  source_uuid?: string,
  destination_uuid?: string,
  uuid: string,
  summary: string,
  description: string | null,
  filter_rule: FilterRule | null,
  status_transform: StatusTransform | null,
  visibility: EventVisibility | null,
  color: string | null,
  keep_location: boolean | null,
  include_conference_link: boolean | null,
  transparency: Transparency | null,
  buffer: SyncRuleBuffer | null,
  include_all_day_events: boolean | null,
  maintain_event_id: boolean | null,
  reminders: EventReminders | null,
}

